const ActivationEnum = {
    ACTIVE: {
        id: 1,
        name: "Si",
        status: "Activo"
    },
    INACTIVE: {
        id: 0,
        name: "No",
        status: "Inactivo"
    },
    getAll() {
        return [
            this.ACTIVE,
            this.INACTIVE,
        ]
    }
}

export default ActivationEnum